import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function useSentryAppSectionTag() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const isSite = path.startsWith("/site");
    const section = isSite ? "site" : "intranet";
    Sentry.setTag("app_section", section);
  }, [location]);
}

export default useSentryAppSectionTag;
